import { Box } from '@mui/material'
import PropTypes from 'prop-types'

const classes = {
    root: {
        width: 16,
        height: 16,
        borderRadius: 0.25,
        flexShrink: 0,
    },
}

const LayerColorAdornment = ({ color = 'blue', sx = null }) => {
    const colorIsNone = !color || color.toLowerCase() === 'none'

    return (
        <Box
            style={colorIsNone ? { border: '0.5px dashed black' } : { backgroundColor: color }}
            sx={[classes.root, ...(Array.isArray(sx) ? sx : [sx])]}
        />
    )
}

LayerColorAdornment.propTypes = {
    color: PropTypes.string,
    sx: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])),
        PropTypes.func,
        PropTypes.object,
    ]),
}

export default LayerColorAdornment
